module.exports = __webpack_public_path__ + "img/912RW.0a41b4bd.png";